import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import queryString from "query-string";
import {
  useGetGrupo,
  useGetPeriodo,
  useGetMatriculadosGrupo,
} from "hooks/useRequest";
import { Mutation } from "hooks/useMutation";
import { ExportToCsv } from "export-to-csv";
import { desmatricularDocente } from "./mutations";
import { isEidu } from "utilites/periodoTypes";

function siNo(value: boolean | null | undefined) {
  if (value === true) return "Sí";
  if (value === false) return "No";
  return "";
}

function mapDocenteCsvEidu(docente: any, tallerNombre: string) {
  return {
    Nombre: docente.nombre ?? "",
    Identificación: docente.identificacion ?? "",
    País: docente.pais ?? "",
    "Correo de contacto": docente.correoInstitucional ?? "",
    Teléfono: docente.telefono ?? "",
    "Perteneciente a": docente.universidad ?? "",
    "Unidad Académica": docente.unidad ?? "",
    "Programa / Carrera": docente.carrera ?? "",
    Taller: tallerNombre ?? "",
    "Tiene discapacidad": siNo(docente.tieneDiscapacidad),
    "Tipo de discapacidad": docente.tipoDiscapacidad ?? "",
    "Requiere apoyo": siNo(docente.requiereApoyo),
    "Detalle de apoyo": docente.detalleApoyo ?? "",
  };
}

function mapDocenteCsvGeneral(docente: any) {
  return {
    Nombre: docente.nombre ?? "",
    Identificación: docente.identificacion ?? "",
    "Unidad Académica": docente.unidad ?? "",
    Carrera: docente.carrera ?? "",
    Nombramiento: docente.condicion ?? "",
    "Correo Institucional": docente.correoInstitucional ?? "",
    "Correo Secundario": docente.correoSecundario ?? "",
    Teléfono: docente.telefono ?? "",
    Comprobante: docente.comprobante ?? "",
  };
}

export const useListaMatriculados = () => {
  const [isDeleteModalVisible, setDeleteModalVisible] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [filteredDataDocente, setFilteredData] = useState<any[]>([]);
  const history = useHistory();

  const { search } = useLocation();
  const { grupo, periodo } = queryString.parse(search);

  const { data, refetch } = useGetGrupo({
    //@ts-ignore
    id: parseInt(grupo),
  });

  const { data: periodoMatricula, refetch: refetchPeriodo } = useGetPeriodo({
    //@ts-ignore
    id: parseInt(periodo),
  });

  const {
    data: docentesMatriculados,
    isLoading,
    isFetching,
    refetch: refetchDocentesMatriculados,
  } = useGetMatriculadosGrupo({
    //@ts-ignore
    id: parseInt(grupo),
  });

  const isEiduPeriodo = isEidu(
    periodoMatricula?.tipoPeriodo?.id ?? data?.periodoMatricula?.tipoPeriodo?.id
  );

  const refetchData = () => {
    refetchPeriodo();
    refetchDocentesMatriculados();
    refetch();
  };

  const mutation = Mutation(desmatricularDocente, refetchData);

  const handleOnEdit = (id: any) => {
    history.push({
      pathname: `/admin/editar-docente`,
      search: `?docente=${id}&grupo=${grupo}&periodo=${periodo}`,
    });
  };

  const handleDelete = (id: any) => {
    setDeleteModalVisible(true);
    setSelectedId(id);
  };

  const handleOkDelete = () => {
    /*@ts-ignore*/
    mutation.mutate({ docente: parseInt(selectedId), grupo: grupo });
    setDeleteModalVisible(false);
  };

  const handleCancelDelete = () => {
    setDeleteModalVisible(false);
    setSelectedId(null);
    refetchData();
  };

  const handleGoBack = () => {
    history.push({
      pathname: "/admin/periodo-matricula",
      search: `?periodo=${periodo}`,
    });
  };

  const handleExport = () => {
    const rows = filteredDataDocente ?? [];
    const exportRows = isEiduPeriodo
      ? rows.map((docente: any) =>
          mapDocenteCsvEidu(docente, data?.nombre ?? "")
        )
      : rows.map((docente: any) => mapDocenteCsvGeneral(docente));

    const csvExporter = new ExportToCsv({
      fieldSeparator: ",",
      quoteStrings: '"',
      decimalSeparator: ".",
      showLabels: true,
      showTitle: true,
      filename: `lista-matriculados-${periodoMatricula?.nombre}-${data?.nombre}`,
      title: isEiduPeriodo
        ? `Lista de inscritos EIDU — ${periodoMatricula?.nombre} — ${data?.nombre}`
        : `Lista de Matriculados de ${periodoMatricula?.nombre} - ${data?.nombre} - ${data?.horario}: ${data?.horaEntrada} a ${data?.horaSalida} - ${data?.nombreProfesor}`,
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true,
    });
    csvExporter.generateCsv(exportRows);
  };

  const handleClickMatricularDocente = () =>
    history.push(`/admin/lista-docentes?grupo=${data.id}&periodo=${periodo}`);

  useEffect(() => {
    const mapped = (docentesMatriculados ?? []).map((item: any) => {
      const docente = { ...item.docente };
      if (docente.comprobante) {
        docente.comprobante = `${process.env.REACT_APP_MEDIA_URL}${docente.comprobante}`;
      }
      return docente;
    });
    setFilteredData(mapped);
  }, [docentesMatriculados]);

  return {
    docentesMatriculados,
    data,
    filteredDataDocente,
    isLoading,
    isFetching,
    isDeleteModalVisible,
    isEiduPeriodo,
    handleCancelDelete,
    handleOnEdit,
    handleDelete,
    handleGoBack,
    handleOkDelete,
    handleExport,
    handleClickMatricularDocente,
  };
};
